export const SUPPORTED = ["ko", "en"] as const;
export type Locale = (typeof SUPPORTED)[number];

export type FlowMode = "briefOnly" | "liveOnly" | "both";

export type ModelTurn = {
  parts?: {
    inlineData?: {
      mimeType: string;
      data: string;
    };
  }[];
};

export type LiveServerMessage = {
  serverContent?: {
    modelTurn?: ModelTurn;
    turnComplete?: boolean;
    interrupted?: boolean;
    inputTranscription?: { text: string };
    outputTranscription?: { text: string };
  };
  [key: string]: unknown;
};

export const ConnectionState = {
  DISCONNECTED: "disconnected",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  RECONNECTING: "reconnecting",
  ERROR: "error",
} as const;

export type ConnectionState =
  (typeof ConnectionState)[keyof typeof ConnectionState];

// 상태 정의
export const Phase = {
  IDLE: "idle",
  READING_SCRIPT: "reading_script",
  BRIEFING_COMPLETED: "briefing_completed",
  LIVE_CONSULTATION: "live_consultation",
} as const;

export type Phase = (typeof Phase)[keyof typeof Phase];

export type QuestionPhase = "idle" | "listening" | "answering";
